import React from 'react';
import { Field, CccisdWysiwyg } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    title: 'Weekly Progress Report',
    description:
        "The Weekly Progress Report shows a participant's progress from week to week over the course of the program. Participants receive a progress score for each week, which ranges from 0 to 28 (low to high). Higher scores are indicative of better in-group behavior for that week.",
};

const Component = props => {
    return (
        <div>
            <Field name="title" component={CccisdWysiwyg} label="Title" />
            <Field name="description" component={CccisdWysiwyg} label="Description" />
        </div>
    );
};

// widgetBuilder is a Formik Wrapper.
export default widgetBuilder({ initialValues })(Component);
